import styled from 'styled-components';
import { fade } from '@material-ui/core';

export const TotalContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: 30px 1fr;
    grid-template:  
        "icon value" 1fr
        ". description" auto / 30px 1fr;
    align-items: center;
    ${({ theme }) => `
        gap: 0 ${theme.spacing(1)}px;
    `}
`;

export const Circle = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: ${({ theme }) => fade(theme.palette.primary.main, 0.16)};
`;